import V3Check from './V3Check'
import { CheckUtils } from 'utils'
import { MiniNotice, HelpLink } from 'components'

const ERROR_ICON = <img src="//decm9lxovq8aw.cloudfront.net/images/customerwebsite/error.png" />

export default class V3HeadingCheck extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderGoodStructureSnippet() {
    return `
    <body>
        <h1>Men's Red Parka Winter Jacket</h1>
        <p>Stay both stylish and warm in temperatures of -20 to -30 degrees.</p>

        <h2>Garment care instructions</h2>
        <p>Dry clean only. Recommended to clean at least once a season.</p>
        
        <h2>Returns information</h2>
        <p>We offer free 30-day returns within Canada.</p>
    </body>`
  }

  renderInfo() {
    let planSpecificInstructions = '';
    if(this.context.currentUser.appPlan == 'free') {
      planSpecificInstructions = (
        <div>
          {this.renderFreeFixInstructions()}
        </div>
      )
    }

    return (
      <div>
        <div>
          <h2>Key points</h2>
          <p>
            The primary heading is an &lt;h1&gt; HTML tag located in the &lt;body&gt; of each page on your site.
          </p>
          <hr />
          <h2>How it's used</h2>
          <ul>
            <li>Used in search engine algorithms</li>
            <li>Carries more weight for ranking than subheadings or normal body text</li>
            <li>Including keywords here strongly guides search engines on what this page is about</li>
          </ul>
          <hr />
          <h2>Best practice</h2>
          <ul>
            <li>Always include one &lt;h1&gt; as the main topic of the page</li>
            <li>Headings should be in text, not images</li>
            <li>Make the heading a sentence or less, naturally including your keywords</li>
            <li>
              For example: 
              <pre className="details__content__code-example">{ this.renderGoodStructureSnippet() }</pre>
            </li>
          </ul>
          <hr />
        </div>

        <div>
          {this.renderFreeFixInstructions()}
        </div>
      </div>
    )
  }

  renderFreeFixInstructions() {
    const pageType = localStorage.getItem('pageType').replace(':', '').replace('page_type.', '')
    let headingHTML = '';

    switch(pageType) {
      case "homepage":
        headingHTML = (
          <div>
            {this.renderHomepageInstructions()}
          </div>
        )
        break
      case "catalog":
        headingHTML = (
          <div>
            {this.renderCatalogInstructions()}
          </div>
        )
        break
      case "collection":
        headingHTML = (
          <div>
            {this.renderCollectionInstructions()}
          </div>
        )
        break
      case "product":
        headingHTML = (
          <div>
            {this.renderProductInstructions()}
          </div>
        )
        break
      case "blogHome":
        headingHTML = (
          <div>
            {this.renderBlogHomeInstructions()}
          </div>
        )
        break
      case "blogPost":
        headingHTML = (
          <div>
            {this.renderBlogPostInstructions()}
          </div>
        )
        break
      case "page":
        headingHTML = (
          <div>
            {this.renderPageInstructions()}
          </div>
        )
        break
      default:
        headingHTML = (
          <div>
            {this.renderOtherInstructions()}
          </div>
        )
        break
    }

    return (
      <div>
        <h2>Fix this yourself</h2>

        {headingHTML}
      </div>
    )
  }

  renderSchema() {
    return `
    <div>
      <div>
        {% if section.settings.heading != blank %}
          <h1 style="text-align:center;margin-left:24px;margin-right:24px;">{{ section.settings.heading }}</h1>
        {% endif %}
        {% if section.settings.subheading != blank %}
          <h2 style="text-align:center;margin-left:24px;margin-right:24px;">{{ section.settings.subheading }}</h2>
        {% endif %}
      </div>
    </div>

    {% schema %}
    {
    "name": {
      "en": "SEO Headings"
    },
    "class": "index-section",
    "settings": [
      {
        "type": "text",
        "id": "heading",
        "label": {
          "en": "Heading"
        },
        "default": {
          "en": "Add your primary heading here"
        }
      },
      {
        "type": "text",
        "id": "subheading",
        "label": {
          "en": "Subheading"
        },
        "default": {
          "en": "Add your subheading here"
        }
      }
    ],
    "presets": [
      {
        "name": {
          "en": "SEO Headings"
        },
        "category": {
          "en": "SEO"
        }
      }
    ]
    }
    {% endschema %}`
  }

  renderAddSectionCode() {
    return `{% section 'seo-headings' %}`
  }

  renderHeadingEdit() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <p>Every theme is structured differently so you will first have to locate which piece of text in your theme is being defined as your heading.</p>

        <ol>
          <li>View your website</li>
          <li>Right-click and select ‘View Page Source’</li>
          <li>Type Control+F (Command+F on a Mac) to open the search box</li>
          <li>Search for <code>&lt;/h1&gt;</code> in the file to find the primary heading</li>
          <li>The text between the <code>&lt;h1&gt;&lt;/h1&gt;</code> is your primary heading</li>
        </ol>

        <p>Once you have identified the text that you will need to locate where to edit it. Most primary heading text can be changed inside your theme ‘Customize’ settings.</p>

        <ol>
          <li><a href={themesLink}>View your themes</a> in Shopify</li>
          <li>Select ‘Customize’ for your live theme</li>
          <li>Find the origin of that text inside your ‘Customize’ settings</li>
          <li>Update the text to include provide a summary of your products and brand. Include 2-3 of your top keywords.</li>
        </ol>
      </div>
    )
  }

  renderDoubleNotice() {
    return (
      <div>
        <MiniNotice
          alert
          header="Coding required"
          note={
            <span>New to coding? <a href="https://support.pluginuseful.com/hc/en-us/articles/23534791516308-A-Guide-to-HTML-Code-Basics" target="_blank">Read our guide of HTML code basics</a></span>
          }
        />
        <MiniNotice
          error
          header="Site styles may be affected"
          note="We strongly recommend testing changes in a theme copy."
        />
      </div>
    )
  }

  renderHeadingGuide() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <ol>
          <li><a href={themesLink}>View your themes</a> in Shopify</li>
          <li>Select ‘Actions’ and  ‘Edit code’ for the relevant theme</li>
          <li>Go the the Sections folder</li>
          <li>Click ‘Add a new section'</li>
          <li>Call it seo-headings</li>
          <li>Create section</li>
          <li>Delete the file content</li>
          <li>
            Add the following piece of code to the new section file and save
            <pre className="details__content__code-example details__content__code-example--condensed">{ this.renderSchema() }</pre>
          </li>
          <li>Go to ‘Customize theme’</li>
          <li>Add the new section called 'SEO Headings'</li>
          <li>Move the section to the desired location on the page</li>
          <li>Input your heading text to provide a summary of your products and brand. Include 2-3 of your top keywords.</li>
        </ol>
      </div>
    )
  }

  renderRemoveAdditionalHeadings() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <h3>Remove additional headings</h3>
        { this.renderDoubleNotice() }

        <p>Every theme is structured differently so you will first have to locate which pieces of text in your theme is being defined as your heading.</p>

        <ol>
          <li>View your website</li>
          <li>Right click and select ‘View Page Source’</li>
          <li>Type Control+F (Command+F on a Mac) to open the search box</li>
          <li>Search for <code>&lt;/h1&gt;</code>  in the file to find the primary headings</li>
          <li>The text between the <code>&lt;h1&gt;</code><code>&lt;/h1&gt;</code> tags are your headings</li>
          <li>Decide which heading you would like to keep and which heading(s) to remove</li>
        </ol>

        <p>If the text inside the additional headings is not necessary you can remove the additional headings.</p>

        <ol>
          <li><a href={themesLink}>View your themes</a> in Shopify</li>
          <li>Select ‘Customize’ for your live theme</li>
          <li>Find the origin of that text inside your ‘Customize’ settings</li>
          <li>Remove that text from your webpage</li>
        </ol>

        <p>If you don’t want to remove the text inside the heading you can change the HTML tags around the heading.</p>

        <ol>
          <li>Determine which piece of text on your site you would like to change to a non-heading</li>
          <li>Determine which section this text comes from</li>
          <li>Find this section in the ‘Sections’ folder of your theme code</li>
          <li>Open the relevant section</li>
          <li>Change the HTML tags to <code>&lt;h2&gt;&lt;/h2&gt;</code> tags</li>
          <li>Save and preview the changes</li>
          <li>If you are happy with the results you can publish the updated theme</li>
        </ol>
      </div>
    )
  }

  renderHomepageInstructions() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <h3>Edit your homepage heading</h3>
        { this.renderHeadingEdit() }

        <h3>Add a homepage heading</h3>
        { this.renderDoubleNotice() }
        <p>By creating a new section on your homepage you can add a new piece of text as your primary heading.</p>

        { this.renderHeadingGuide() }

        { this.renderRemoveAdditionalHeadings() }

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534773634708-What-can-I-do-if-updating-my-heading-h1-h1-changes-the-styling-of-my-website-or-text"
            title="Updating my heading tags &lt;h1&gt;&lt;/h1&gt; changes the styling of my website"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534773552788-What-should-I-do-if-I-have-heading-tags-h1-h1-around-my-logo"
            title="I have heading tags &lt;h1&gt;&lt;/h1&gt; around my logo"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderCatalogInstructions() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <h3>Edit your catalog heading</h3>
        { this.renderHeadingEdit() }

        <h3>Add a catalog heading</h3>
        { this.renderDoubleNotice() }
        <p>First, you will need to create a new section in your theme.</p>
        <ol>
          <li><a href={themesLink} target="_blank">View your themes</a> in Shopify</li>
          <li>Select ‘Actions’ and  ‘Edit code’ for the relevant theme</li>
          <li>Go the 'Sections' folder</li>
          <li>Click ‘Add a new section;</li>
          <li>Call it seo-headings</li>
          <li>Create section</li>
          <li>Delete the file content</li>
          <li>
            Add the following piece of code to the new section file and save
            <pre className="details__content__code-example details__content__code-example--condensed">{ this.renderSchema() }</pre>
          </li>
        </ol>

        <p>Next, you will need to add this section to your catalog page. For most themes, this will need to be done by manually editing the code.</p>
        <ol>  
          <li>Go to the 'Templates' folder</li>
          <li>Find the template file for your catalog page. It is likely called something like list-collections.liquid.</li>
          <li>
            Add the following code to the file and save
            <pre className="details__content__code-example small-spacing--top">{ this.renderAddSectionCode() }</pre>
          </li>
          <li>Adjust placement on the page. You will likely see other sections listed in this file, place the seo-headings section above or below these sections as desired.</li>
        </ol>

        <p>Finally, you can edit add your heading to this new section.</p>
        <ol>
          <li>Go to ‘Customize theme’</li>
          <li>Select the 'Collections List' page</li>
          <li>View the new section called 'SEO Headings'</li>
          <li>Input your heading text to provide a summary of your products and brand. Include 2-3 of your top keywords.</li>
        </ol>

        { this.renderRemoveAdditionalHeadings() }

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534792492052-What-should-I-do-if-I-cannot-find-my-heading-in-my-customize-theme-admin"
            title="I cannot find my heading in my ‘customize theme’ admin"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534773634708-What-can-I-do-if-updating-my-heading-h1-h1-changes-the-styling-of-my-website-or-text"
            title="Updating my heading tags &lt;h1&gt;&lt;/h1&gt; changes the styling of my website"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534773552788-What-should-I-do-if-I-have-heading-tags-h1-h1-around-my-logo"
            title="I have heading tags &lt;h1&gt;&lt;/h1&gt; around my logo"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderCollectionInstructions() {
    const currentUser = this.context.currentUser
    const collectionsLink = 'https://' + currentUser.shop + '/admin/collections'

    return (
      <div>
        <h3>Edit your collection heading</h3>
        <p>For most themes the heading <code>&lt;h1&gt;&lt;/h1&gt;</code> is the title of the collection.</p>

        <ol>
          <li><a href={collectionsLink} target="_blank">Go to your collections</a> in your Shopify admin</li>
          <li>View the relevant collection page</li>
          <li>Edit the text in the ‘Title’ field</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534741178516-How-can-I-verify-that-my-primary-heading-h1-h1-is-my-title"
            title="How can I verify that my primary heading &lt;h1&gt;&lt;/h1&gt; is my title?"
          />
          <HelpLink
            url="https://pembertonrank.zendesk.com/hc/en-us/articles/360002720418"
            title="My title is not currently the primary heading &lt;h1&gt;&lt;/h1&gt; of my page"
          />
        </ul>
      </div>
    )
  }

  renderProductInstructions() {
    const currentUser = this.context.currentUser
    const productsLink = 'https://' + currentUser.shop + '/admin/products'

    return (
      <div>
        <h3>Edit your product heading</h3>
        <p>For most themes the heading <code>&lt;h1&gt;&lt;/h1&gt;</code> is the title of the product.</p>

        <ol>
          <li><a href={productsLink} target="_blank">Go to your products</a> in your Shopify admin</li>
          <li>View the relevant product page</li>
          <li>Edit the text in the ‘Title’ field</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534741178516-How-can-I-verify-that-my-primary-heading-h1-h1-is-my-title"
            title="How can I verify that my primary heading &lt;h1&gt;&lt;/h1&gt; is my title?"
          />
          <HelpLink
            url="https://pembertonrank.zendesk.com/hc/en-us/articles/360002720418"
            title="My title is not currently the primary heading &lt;h1&gt;&lt;/h1&gt; of my page"
          />
        </ul>
      </div>
    )
  }

  renderBlogHomeInstructions() {
    const currentUser = this.context.currentUser
    const blogsLink = 'https://' + currentUser.shop + '/admin/blogs'

    return (
      <div>
        <h3>Edit your blog heading</h3>
        <p>For most themes the heading <code>&lt;h1&gt;&lt;/h1&gt;</code> is the title of the blog.</p>

        <ol>
          <li><a href={blogsLink} target="_blank">Go to your blogs</a> in your Shopify admin</li>
          <li>View the relevant blog</li>
          <li>Edit the text in the ‘Title’ field</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534741178516-How-can-I-verify-that-my-primary-heading-h1-h1-is-my-title"
            title="How can I verify that my primary heading &lt;h1&gt;&lt;/h1&gt; is my title?"
          />
          <HelpLink
            url="https://pembertonrank.zendesk.com/hc/en-us/articles/360002720418"
            title="My title is not currently the primary heading &lt;h1&gt;&lt;/h1&gt; of my page"
          />
        </ul>
      </div>
    )
  }

  renderBlogPostInstructions() {
    const currentUser = this.context.currentUser
    const articlesLink = 'https://' + currentUser.shop + '/admin/articles'

    return (
      <div>
        <h3>Edit your blog post heading</h3>
        <p>For most themes the heading <code>&lt;h1&gt;&lt;/h1&gt;</code> is the title of the blog post.</p>

        <ol>
          <li><a href={articlesLink} target="_blank">Go to your blog posts</a> in your Shopify admin</li>
          <li>View the relevant blog post</li>
          <li>Edit the text in the ‘Title’ field</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534741178516-How-can-I-verify-that-my-primary-heading-h1-h1-is-my-title"
            title="How can I verify that my primary heading &lt;h1&gt;&lt;/h1&gt; is my title?"
          />
          <HelpLink
            url="https://pembertonrank.zendesk.com/hc/en-us/articles/360002720418"
            title="My title is not currently the primary heading &lt;h1&gt;&lt;/h1&gt; of my page"
          />
        </ul>
      </div>
    )
  }

  renderPageInstructions() {
    const currentUser = this.context.currentUser
    const pagesLink = 'https://' + currentUser.shop + '/admin/pages'

    return (
      <div>
        <h3>Edit your pages heading</h3>
        <p>For most themes the heading <code>&lt;h1&gt;&lt;/h1&gt;</code> is the title of the page.</p>

        <ol>
          <li><a href={pagesLink} target="_blank">Go to your pages</a> in your Shopify admin</li>
          <li>View the relevant page</li>
          <li>Edit the text in the ‘Title’ field</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534741178516-How-can-I-verify-that-my-primary-heading-h1-h1-is-my-title"
            title="How can I verify that my primary heading &lt;h1&gt;&lt;/h1&gt; is my title?"
          />
          <HelpLink
            url="https://pembertonrank.zendesk.com/hc/en-us/articles/360002720418"
            title="My title is not currently the primary heading &lt;h1&gt;&lt;/h1&gt; of my page"
          />
        </ul>
      </div>
    )
  }

  renderOtherInstructions() {

    return (
      <div>
        <h3>Edit your heading</h3>
        {this.renderHeadingEdit()}

        <h3>Add a heading</h3>
        {this.renderDoubleNotice()}
        <p>By creating a new section on your you can add a new piece of text as your primary heading.</p>

        {this.renderHeadingGuide()}

        {this.renderRemoveAdditionalHeadings()}

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534792492052-What-should-I-do-if-I-cannot-find-my-heading-in-my-customize-theme-admin"
            title="I cannot find my heading in my ‘customize theme’ admin"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534773634708-What-can-I-do-if-updating-my-heading-h1-h1-changes-the-styling-of-my-website-or-text"
            title="Updating my heading tags &lt;h1&gt;&lt;/h1&gt; changes the styling of my website"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534773552788-What-should-I-do-if-I-have-heading-tags-h1-h1-around-my-logo"
            title="I have heading tags &lt;h1&gt;&lt;/h1&gt; around my logo"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3HeadingCheck.js